const fns = {
  getElementById: 'byID',
  getElementsByClassName: 'byClass',
  querySelector: 'querySelector',
  querySelectorAll: 'querySelectorAll'
}

export const getElementsBy = (fnName, selectors) => [...selectors].reduce((obj, selector) => {
  // * Memoize elements
  try {
    let key = fns[fnName]
    MK.DOM.elements[key][selector] = MK.DOM.elements && MK.DOM.elements[key] && MK.DOM.elements[key][selector] || document[fnName](selector)
    obj[selector] = obj[selector] || MK.DOM.elements[key][selector]

    if (!obj[selector]) throw Error(`!!! ERROR (DOM.fns.getElementsBy): Unable to locate element with function ${fnName} using selector: ${selector}`)

    return obj
  } catch (error) {
    console.log(error)
    MK.captureException && MK.captureException(error)
    return {}
  }
}, {})